// extracted by mini-css-extract-plugin
module.exports = {"headerLayout":"style_headerLayout__2Dpqf"};